// @flow
import * as React from 'react';
import { translate } from 'react-i18next';
import { withTheme } from 'styled-components';
import PieChart from './wrappers/PieChart';

type Props = {
  female: number;
  male: number;
  height: number;

  t: (key: string) => string;
  theme: Object;
}

function GenderPie({ female, male, height, t, theme }: Props) {
  const data = [
    { name: t('gender.women'), value: female, color: theme.V3.colors.female },
    { name: t('gender.men'), value: male, color: theme.V3.colors.male },
  ];

  return (
    <PieChart
      data={data}
      height={height}
    />
  );
}

export default translate()(withTheme(GenderPie));



// WEBPACK FOOTER //
// ./src/common/components/ui/charts/GenderPie.js